import { render, staticRenderFns } from "./chooselink.vue?vue&type=template&id=2f696c38&scoped=true&"
import script from "./chooselink.vue?vue&type=script&lang=js&"
export * from "./chooselink.vue?vue&type=script&lang=js&"
import style0 from "./chooselink.vue?vue&type=style&index=0&id=2f696c38&prod&lang=css&"
import style1 from "./chooselink.vue?vue&type=style&index=1&id=2f696c38&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f696c38",
  null
  
)

export default component.exports